import {createContext, Dispatch} from 'react';
import {initialSoftTickerData, SoftTickerData} from 'app/reducers/softTickerReducer';

export const SoftTickerContext = createContext<SoftTickerData>(initialSoftTickerData);
export const SoftTickerDispatchContext = createContext<Dispatch<any> | null>(null);
